import { useEffect } from 'react';

const getWidth = (ref) => ref?.current?.offsetWidth || 0;

export const useOverflowObserver = (containerRef, contentRef, callback) => {
  useEffect(() => {
    const handleResize = () => {
      const containerWidth = getWidth(containerRef);
      const contentWidth = getWidth(contentRef);

      callback(containerWidth <= contentWidth);
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [
    containerRef?.current?.offsetWidth,
    contentRef?.current?.offsetWidth,
    callback,
  ]);
};
